import { useMemo } from "react";
import { Submission } from "@/bryntum-lib/models/Submission";
import { useLeadsContext } from "../context/LeadsContext";
import { useSubmissions } from "./useSubmissions";

function submissionSearchText(s: Submission): string {
  return `${s.name ?? ""} ${s.email ?? ""} ${s.phone ?? ""} ${s.message ?? ""} ${s.additionalNotes ?? ""}`.toLowerCase();
}

export function useFilteredLeads() {
  const { submissions } = useSubmissions();
  const { query, sortMode, sourceFilter } = useLeadsContext();

  const hasActiveFilters =
    query.trim() !== "" || sourceFilter !== "all" || sortMode !== "date_desc";

  const filteredSubmissions = useMemo(() => {
    let rows = [...submissions];

    if (sourceFilter !== "all") {
      rows = rows.filter((s) => s.source === sourceFilter);
    }

    const q = query.trim().toLowerCase();
    if (q) {
      rows = rows.filter((s) => submissionSearchText(s).includes(q));
    }

    rows.sort((a, b) => {
      if (sortMode === "name_asc") {
        return (a.name ?? "").localeCompare(b.name ?? "", undefined, { sensitivity: "base" });
      }
      const ta = a.createdAt ? new Date(a.createdAt).getTime() : 0;
      const tb = b.createdAt ? new Date(b.createdAt).getTime() : 0;
      return sortMode === "date_asc" ? ta - tb : tb - ta;
    });

    return rows;
  }, [submissions, query, sortMode, sourceFilter]);

  return { submissions, filteredSubmissions, hasActiveFilters };
}
